// extracted by mini-css-extract-plugin
export default {"grid":"delivery-stats-grid_grid__GqzVB"};